import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import {
  IGetDashboardFinanceiroParams,
  IGetDashboardFinanceiroResponse,
  IGetDashboardPatioParams,
  IGetDashboardPatioResponse,
  IGetDashboardServicosParams,
  IGetDashboardServicosResponse
} from './dashboard.model';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {
  constructor(private http: HttpClient) {}

  public getDashboardServicos(
    params?: IGetDashboardServicosParams
  ): Observable<IGetDashboardServicosResponse> {
    const url = `${environment.baseURL}Report/GetDashboardServicos`;
    return this.http.get<IGetDashboardServicosResponse>(url, {
      params: this.buildParams(params)
    });
  }

  public getDashboardFinanceiro(
    params?: IGetDashboardFinanceiroParams
  ): Observable<IGetDashboardFinanceiroResponse> {
    const url = `${environment.baseURL}Report/GetDashboardFinanceiro`;
    return this.http.get<IGetDashboardFinanceiroResponse>(url, {
      params: this.buildParams(params)
    });
  }

  public getDashboardPatio(
    params?: IGetDashboardPatioParams
  ): Observable<IGetDashboardPatioResponse> {
    const url = `${environment.baseURL}Report/GetDashboardPatio`;
    return this.http.get<IGetDashboardPatioResponse>(url, {
      params: this.buildParams(params)
    });
  }

  private buildParams(
    params?:
      | IGetDashboardServicosParams
      | IGetDashboardPatioParams
      | IGetDashboardFinanceiroParams
  ): HttpParams {
    let httpParams = new HttpParams();
    if (!params) {
      return httpParams;
    }

    Object.entries(params).forEach(([key, value]) => {
      if (value !== null && value !== undefined && String(value).trim() !== '') {
        httpParams = httpParams.set(key, String(value));
      }
    });

    return httpParams;
  }
}
